import { useTranslation } from "react-i18next";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";

type Params = {
  value: "SAME" | "INDIVIDUAL";
  onChange: (value: "SAME" | "INDIVIDUAL") => void;
};

export default function SyncByRuleSelector({
  value,
  onChange: emitChange,
}: Params) {
  const { t } = useTranslation("rules");

  return (
    <RadioGroup
      style={{ marginBottom: 24 }}
      value={value}
      onChange={(_, value: string) => {
        emitChange(value as "SAME" | "INDIVIDUAL");
      }}
    >
      <FormControlLabel
        value="INDIVIDUAL"
        control={<Radio color="primary" size="small" />}
        label={
          <Typography variant="caption" style={{ fontSize: 14 }}>
            {t(`targetStep.syncAllByRule.disabled`)}
          </Typography>
        }
      />
      <FormControlLabel
        value="SAME"
        control={<Radio color="primary" size="small" />}
        label={
          <Typography variant="caption" style={{ fontSize: 14 }}>
            {t(`targetStep.syncAllByRule.enabled`)}
          </Typography>
        }
      />
    </RadioGroup>
  );
}
